import * as React from "react"
import { createTheme, CssBaseline, GlobalStyles, PaletteMode, ThemeProvider } from "@mui/material"

import { context } from "@core-ts/Contexts/Context"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { mergeObjects } from "@core-ts/helperLibrary"

export interface StandardAppStyling {
    logo?: string
    logoSize?: number // In pixels
    headerSize: number // In pixels
    favicon?: string
    primaryColor: string
    secondaryColor: string
    mode: "light" | "dark"
    headerColor?: string
    oldStyle?: boolean // To support the old PHP look
    font: string
    styleOverrides: Record<string, unknown>
    backgroundImage?: string
    manifestName?: string
    manifestShortName?: string
    manifestIcon?: string
    manifestStartUrl?: string
    manifestIcon192?: string
    manifestIcon512?: string
    headerBackgroundColor?: string
    headerTextColor?: string
}

export interface FontStyle {
    fontFamily: string
    src: string
    fontWeight: number
    fontStyle: string
}

interface BasicMuiStylesProps {
    style: StandardAppStyling
    children: React.ReactNode
}

export function applyDefaultsAndStylesFromConfig(baseStyle: Partial<StandardAppStyling>): StandardAppStyling {
    // The config may override the base style
    const finalStyle: StandardAppStyling = {
        logo: context.config.getString("logo", baseStyle.logo ?? ""),
        logoSize: context.config.getNumber("logoSize", baseStyle.logoSize ?? 32),
        headerSize: context.config.getNumber("headerSize", baseStyle.headerSize ?? 64),
        favicon: context.config.getStringWithUndefined("favicon", baseStyle.favicon ?? undefined),
        primaryColor: context.config.getString("primaryColor", baseStyle.primaryColor ?? "#28ACE0"),
        secondaryColor: context.config.getString("secondaryColor", baseStyle.secondaryColor ?? "#00B0FF"),
        mode: context.config.getString("mode", baseStyle.mode ?? "light") as PaletteMode,
        headerColor: context.config.getStringWithUndefined("headerColor", baseStyle.headerColor),
        font: context.config.getString("font", baseStyle.font ?? "Roboto"),
        styleOverrides: baseStyle.styleOverrides ?? {},
        backgroundImage: context.config.getStringWithUndefined("backgroundImage", baseStyle.backgroundImage),
    }

    return finalStyle
}
declare var frontendConfig: Record<string, unknown>

export function BasicMuiStyles(props: BasicMuiStylesProps): React.JSX.Element {
    const link: HTMLLinkElement | null = null

    document.title =
        (frontendConfig as any)?.instanceName ?? context.config.getString("title", context.instance.instanceName)
    React.useEffect(() => {
        console.log("Setting favicon to " + props.style.favicon)
        if (props.style.favicon !== undefined) {
            const link = document.createElement("link")
            link.rel = "icon"
            link.href = props.style.favicon
            document.head.appendChild(link)
        }
    }, [props.style.favicon])

    const themeSettings = mergeObjects(props.style.styleOverrides, {
        palette: {
            mode: props.style.mode,
            primary: {
                main: props.style.primaryColor,
            },
            secondary: {
                main: props.style.secondaryColor,
            },
        },
        typography: {
            fontWeightBold: "bolder",
            fontFamily: props.style.font,
            fontWeightLight: 300,
            fontWeightRegular: 400,
        },

        logo: props.style.logo,
        favicon: props.style.favicon,
        logoSize: props.style.logoSize,
        backgroundImage: props.style.backgroundImage,
    })

    const theme = createTheme(themeSettings)

    return (
        <>
            {/* <GlobalStyles
                styles={
                    {
                        // '@font-face': props.style.fontSources,
                        // 'html, body': {
                        //     fontFamily: props.style.font,
                        //     fontWeight: 400,
                        // },
                        // 'h1, h2, h3, h4, h5, h6, p, span, a, div': {
                        //     fontFamily: props.style.font,
                        //     fontWeight: 'inherit', // Let elements inherit weight from parent if set
                        // },
                    }
                }
            /> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    {props.children}
                </ThemeProvider>
            </LocalizationProvider>
        </>
    )
}
